// ══════════════════════════════════════════════════════════════════
//  Queries do Dashboard (TanStack Query).
//  Cada aba era useState+useEffect isolado → trocar de aba refazia o
//  fetch. Com cache (staleTime curto) a troca de aba reusa os dados;
//  mudar um filtro global (funil/período/escopo) muda a queryKey e
//  revalida automaticamente. (achado #3 da auditoria)
// ══════════════════════════════════════════════════════════════════

import { useQuery } from '@tanstack/react-query';
import { qk } from './keys';
import {
  getFunnelData, getTeamPerformance, getActivitiesStats, getLeadAcquisitionData,
  getEffectiveContactData, getLossReasonsData, getForecastData, getTrackingData,
} from '@app';

// 30s: dados de dashboard mudam, mas o cache cobre a troca rápida de aba.
const STALE = 30 * 1000;

type DashParams = {
  workspaceId?: string;
  funnelId?: string | null;
  startISO?: string | null;
  endISO?: string | null;
  userCtx?: any;
};

const makeOpts = (kind: string, fn: (p: any) => Promise<any>, p: DashParams) => ({
  queryKey: qk.dashboard(kind, p),
  queryFn: () => fn(p),
  enabled: !!p.workspaceId,
  staleTime: STALE,
});

export function useFunnelData(p: DashParams) { return useQuery(makeOpts('funnel', getFunnelData, p)); }
export function useTeamPerformance(p: DashParams) { return useQuery(makeOpts('team', getTeamPerformance, p)); }
export function useActivitiesStats(p: DashParams) { return useQuery(makeOpts('activities', getActivitiesStats, p)); }
export function useLeadAcquisitionData(p: DashParams) { return useQuery(makeOpts('leadAcquisition', getLeadAcquisitionData, p)); }
export function useEffectiveContactData(p: DashParams) { return useQuery(makeOpts('effectiveContact', getEffectiveContactData, p)); }
export function useLossReasonsData(p: DashParams) { return useQuery(makeOpts('lossReasons', getLossReasonsData, p)); }
export function useForecastData(p: DashParams) { return useQuery(makeOpts('forecast', getForecastData, p)); }
export function useTrackingData(p: DashParams) { return useQuery(makeOpts('tracking', getTrackingData, p)); }
